import React from 'react';
import './Loader.css'; 

const Loader = () => {
  return (
    <div className="fixed top-0 left-0 w-full z-[2001] overflow-hidden bg-transparent">
      <div className="relative w-full h-1 bg-secondary-light">
        <div className="absolute left-0 top-0 h-full bg-secondary animate-mui-primary" />
        <div className="absolute left-0 top-0 h-full bg-secondary animate-mui-secondary" />
      </div>
      <style>
        {`
          /* Match MUI secondary color — change as needed */
          .bg-secondary { background-color: rgb(156, 39, 176); } /* purple-500 */
          .bg-secondary-light { background-color: rgba(156, 39, 176, 0.3); }

          @keyframes mui-primary {
            0% {
              left: -35%;
              right: 100%;
            }
            60% {
              left: 100%;
              right: -90%;
            }
            100% {
              left: 100%;
              right: -90%;
            }
          }

          @keyframes mui-secondary {
            0% {
              left: -200%;
              right: 100%;
            }
            60% {
              left: 107%;
              right: -8%;
            }
            100% {
              left: 107%;
              right: -8%;
            }
          }

          .animate-mui-primary {
            animation: mui-primary 2s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
          }

          .animate-mui-secondary {
            animation: mui-secondary 2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
          }
        `}
      </style>
    </div>
  );
};

export default Loader;

